import {
  LOADING_INICIATIVAS_IA,
  LOAD_INICIATIVAS_IA,
  ERROR_INICIATIVAS_IA,
  LOADING_INICIATIVAS_IA_CATALOGOS,
  LOAD_INICIATIVAS_IA_CATALOGOS,
  ERROR_INICIATIVAS_IA_CATALOGOS,
  LOADING_INICIATIVAS_IA_KPI,
  LOAD_INICIATIVAS_IA_KPI,
  ERROR_INICIATIVAS_IA_KPI,
  LOADING_INICIATIVAS_IA_CHAMPIONS,
  LOAD_INICIATIVAS_IA_CHAMPIONS,
  ERROR_INICIATIVAS_IA_CHAMPIONS,
} from "./iniciativasIATypes";

// Estado del módulo "Iniciativas de IA" (spec 008, Incremento 1, plan.md §3.3):
// { loading, error, iniciativas, catalogos, kpi }. `catalogos` trae la forma exacta que arma el
// controlador (plan.md §2.1): { clusters, clubhouses, tiposIA, vigilancia, checklistItems, usuarios }.
const emptyCatalogos = {
  clusters: [],
  clubhouses: [],
  tiposIA: [],
  vigilancia: [],
  checklistItems: [],
  usuarios: [],
};

const initial = {
  loading: false,
  error: false,
  iniciativas: [],
  catalogos: { ...emptyCatalogos },
  kpi: null,
  // Incrementos 2-3 (RF-29/RF-30): esChampion gatea las pestañas del Champion; champions alimenta el
  // desplegable "¿A qué Champion se envía?" del modal de acciones.
  esChampion: false,
  champions: [],
};

const iniciativasIAReducer = (state = initial, action) => {
  switch (action.type) {
    case LOADING_INICIATIVAS_IA:
      return { ...state, loading: true, error: false };
    case LOAD_INICIATIVAS_IA:
      return { ...state, iniciativas: action.payload || [], loading: false, error: false };
    case ERROR_INICIATIVAS_IA:
      return { ...state, iniciativas: [], loading: false, error: true };

    case LOADING_INICIATIVAS_IA_CATALOGOS:
      return { ...state, loading: true, error: false };
    case LOAD_INICIATIVAS_IA_CATALOGOS:
      return {
        ...state,
        catalogos: action.payload || { ...emptyCatalogos },
        loading: false,
        error: false,
      };
    case ERROR_INICIATIVAS_IA_CATALOGOS:
      return { ...state, catalogos: { ...emptyCatalogos }, loading: false, error: true };

    // El KPI se consulta también desde Landing.jsx (tarjeta del dashboard, RF-3), por eso no comparte el
    // flag `loading` genérico con el listado/catálogos: una tarjeta del dashboard no debe bloquear el
    // resto de la UI mientras carga.
    case LOADING_INICIATIVAS_IA_KPI:
      return { ...state, error: false };
    case LOAD_INICIATIVAS_IA_KPI:
      return { ...state, kpi: action.payload || null, error: false };
    case ERROR_INICIATIVAS_IA_KPI:
      return { ...state, kpi: null, error: true };

    // Mismo criterio que el KPI: no comparte el flag `loading` genérico (no debe tapar el listado
    // principal mientras resuelve la designación de Champion, que es una consulta independiente).
    case LOADING_INICIATIVAS_IA_CHAMPIONS:
      return { ...state, error: false };
    case LOAD_INICIATIVAS_IA_CHAMPIONS:
      return {
        ...state,
        esChampion: !!(action.payload && action.payload.esChampion),
        champions: (action.payload && action.payload.champions) || [],
        error: false,
      };
    case ERROR_INICIATIVAS_IA_CHAMPIONS:
      return { ...state, esChampion: false, champions: [], error: true };

    default:
      return state;
  }
};

export default iniciativasIAReducer;
